import { useLocalizationStore } from '../stores/useLocalizationStore';

export const useTranslation = () => {
  const { t, getCurrentLanguage, getDirection } = useLocalizationStore();

  return {
    t,
    language: getCurrentLanguage(),
    direction: getDirection(),
    isRTL: getDirection() === 'rtl',
  };
};